const CAPACITY = 50;
const events = [];
const secretKey = /token|password|authorization|cookie|aadhaar|payment|student|employee/i;
export function sanitize(value, depth = 0) {
  if (depth > 3) return '[truncated]';
  if (Array.isArray(value)) return value.slice(0, 10).map((item) => sanitize(item, depth + 1));
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).filter(([key]) => !secretKey.test(key)).map(([key, item]) => [key, sanitize(item, depth + 1)]));
  return typeof value === 'string' ? value.replace(/Bearer\s+[\w.-]+/gi, 'Bearer [redacted]').slice(0, 500) : value;
}
export function recordPwaEvent(type, detail = {}) { events.push({ type, detail: sanitize(detail), at: new Date().toISOString() }); if (events.length > CAPACITY) events.shift(); }
export function recentPwaEvents() { return [...events]; }
